export const DocumentCard = {
  flow: 'y',
  gap: 'Y',
  padding: 'Z',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  cursor: 'pointer',
  transition: 'border 150ms ease, boxShadow 150ms ease',
  ':hover': { border: '1px solid inkSubtle', boxShadow: '0 2px 8px rgba(0,0,0,.12)' },
  width: '100%',
  on: {
    click: (e, el, s) => {
      s.root.update({
        selectedDocument: {
          id: s.id,
          filename: s.filename,
          type: s.docType,
          date: s.date,
          device: s.device,
          tooth: s.tooth,
          patient: s.patient
        }
      })
    }
  },

  Thumbnail: {
    width: '100%',
    height: 'F',
    round: 'Y',
    overflow: 'hidden',
    background: (el, s) => {
      const t = s.docType || 'other'
      if (t === 'xray') return 'ink'
      if (t === 'ctScan') return 'blue.08'
      if (t === 'intraoral3d') return 'violet.08'
      if (t === 'photo') return 'teal.08'
      return 'inkSurface'
    },
    align: 'center center',
    display: 'flex',
    ThumbIcon: {
      extends: 'Icon',
      name: (el, s) => {
        const t = s.docType || 'other'
        if (t === 'xray') return 'scan'
        if (t === 'ctScan') return 'layers'
        if (t === 'intraoral3d') return 'box'
        if (t === 'photo') return 'camera'
        return 'file'
      },
      fontSize: 'C',
      color: (el, s) => {
        const t = s.docType || 'other'
        if (t === 'xray') return 'inkMuted'
        if (t === 'ctScan') return 'blue'
        if (t === 'intraoral3d') return 'violet'
        if (t === 'photo') return 'teal'
        return 'inkMuted'
      }
    }
  },

  InfoSection: {
    flow: 'y',
    gap: 'X',

    TopRow: {
      flow: 'x',
      align: 'center flex-start',
      justifyContent: 'space-between',
      TypeBadge: {
        tag: 'span',
        text: (el, s) => {
          const t = s.docType || 'other'
          if (t === 'xray') return 'X-ray'
          if (t === 'ctScan') return 'CT Scan'
          if (t === 'intraoral3d') return '3D Scan'
          if (t === 'photo') return 'Photo'
          return 'Other'
        },
        fontSize: 'Y',
        fontWeight: '600',
        padding: 'X Y',
        round: 'B',
        background: (el, s) => {
          const t = s.docType || 'other'
          if (t === 'xray') return 'amber.15'
          if (t === 'ctScan') return 'blue.15'
          if (t === 'intraoral3d') return 'violet.15'
          if (t === 'photo') return 'teal.15'
          return 'inkSurface'
        },
        color: (el, s) => {
          const t = s.docType || 'other'
          if (t === 'xray') return 'amber'
          if (t === 'ctScan') return 'blue'
          if (t === 'intraoral3d') return 'violet'
          if (t === 'photo') return 'teal'
          return 'inkMuted'
        }
      },
      ToothLabel: {
        text: (el, s) => s.tooth ? `#${s.tooth}` : '',
        fontSize: 'Y',
        color: 'inkMuted',
        fontWeight: '500'
      }
    },

    Filename: {
      text: (el, s) => s.filename || '',
      fontSize: 'Z',
      fontWeight: '600',
      color: 'inkText',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    MetaRow: {
      flow: 'x',
      gap: 'Y',
      align: 'center flex-start',
      DateLabel: { text: (el, s) => s.date || '', fontSize: 'Y', color: 'inkMuted' },
      Separator: { text: '\u00b7', fontSize: 'Y', color: 'inkMuted' },
      DeviceLabel: { text: (el, s) => s.device || '', fontSize: 'Y', color: 'inkMuted' }
    }
  }
}
